export default __webpack_public_path__ + "static/media/so.cb112a85.svg";